import IconCheck from "./icon-check";

export default IconCheck;
